var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useEffect, useMemo, useState } from 'react';
const PROGRESS_INTERVAL = 20;
const timeouts = [];
export function useProgressBar(messages, totalDuration, progressBarComplete) {
    var _a;
    const [progress, setProgress] = useState(0);
    const [currentMessage, setCurrentMessage] = useState(messages[0]);
    const lastMessage = (_a = messages[messages.length - 1]) !== null && _a !== void 0 ? _a : '';
    const progressBarMessages = useMemo(() => messages.slice(0, -1), [messages]);
    if (progressBarComplete && currentMessage !== lastMessage) {
        /* If the process is complete, then set progress to 100% and display the last message */
        setProgress(100);
        setCurrentMessage(lastMessage);
    }
    const showProgressBar = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        const numMessages = progressBarMessages.length;
        const intervals = [];
        /* 10% time blocked for last message */
        const lastMessageDuration = totalDuration * 0.01;
        intervals[numMessages - 1] = lastMessageDuration;
        let remainingDuration = totalDuration - lastMessageDuration;
        /* Generate random intervals for each message except the last one */
        progressBarMessages.slice(0, -1).forEach((_, idx) => {
            if (idx === numMessages - 2)
                intervals[idx] = remainingDuration;
            else {
                const interval = Math.random() * (remainingDuration / (numMessages - 1 - idx));
                intervals[idx] = interval;
                remainingDuration -= interval;
            }
        });
        let currentProgress = 0;
        for (let i = 0; i < numMessages; i += 1) {
            const intervalDuration = intervals[i];
            const targetProgress = Math.floor(currentProgress + (intervals[i] / totalDuration) * 100);
            const increment = (targetProgress - currentProgress) / PROGRESS_INTERVAL;
            const stepTime = intervalDuration / PROGRESS_INTERVAL;
            // eslint-disable-next-line no-loop-func
            Array.from({ length: PROGRESS_INTERVAL }).forEach((_, j) => {
                const piIndex = j + 1;
                /* Don't complete the bar for last message */
                if (i === numMessages - 1 && piIndex >= Math.floor(Math.random() * 3) + (PROGRESS_INTERVAL - 3))
                    return;
                const timeoutId = setTimeout(() => {
                    currentProgress += increment;
                    setProgress(Math.min(100, Math.floor(currentProgress)));
                }, piIndex * stepTime);
                timeouts.push(timeoutId);
            });
            // eslint-disable-next-line no-await-in-loop
            yield new Promise((resolve) => {
                const messageTimeout = setTimeout(() => {
                    var _a;
                    setCurrentMessage((_a = progressBarMessages[i + 1]) !== null && _a !== void 0 ? _a : progressBarMessages[i]);
                    resolve();
                }, intervalDuration);
                timeouts.push(messageTimeout);
            });
        }
    }), [progressBarMessages, totalDuration]);
    useEffect(() => {
        if (!progressBarMessages.length || !totalDuration || progressBarComplete)
            return;
        showProgressBar();
        // eslint-disable-next-line consistent-return
        return () => {
            timeouts.forEach(clearTimeout);
        };
    }, [progressBarMessages, totalDuration, progressBarComplete, showProgressBar]);
    return { currentMessage, progress };
}
